<template>
    <span class="badge-app border rounded-3 m-1" :class="'app-' + app_id">{{ app_name }}</span>
</template>

<script>
export default {
    name: 'BadgeApp',
    props: {
        app_id: {
            type: Number,
            default: 1,
        },
        app_name: {
            type: String,
            default: '',
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge-app {font-weight: bold; padding: .5rem 1rem; border-color: #acacac !important; white-space: nowrap; line-height: 2.5rem;}
    .app-1 {color: rgb(220, 53, 69);}
    .app-2 {color: rgb(61, 220, 53);}
    .app-3 {color: rgb(103, 103, 103);}
</style>
